import { Module } from "vuex";
import { actions, mutations } from ".";
import { PaginationMeta } from "../../models/pagination.model";
import { SportEvent } from "../../models/sport-events.model";
import { RootState } from "./../index";

export interface SportEventsState {
  sportEvents?: SportEvent[];
  paginationMeta?: PaginationMeta;
}

const state: SportEventsState = {
  sportEvents: [],
  paginationMeta: undefined
};

export const namespaceSportEvents = "sportEvents";

export const sportEventsModule: Module<SportEventsState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations
};

export * from "./sport-events.actions";
export * from "./sport-events.mutations";
